import React from 'react';
import { useAuthStore } from '../store/authStore';
import { Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  department?: string;
}

export default function Header({ department }: HeaderProps) {
  const { isAuthenticated, user, logout } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Logout error:', error);
      navigate('/', { replace: true });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 h-16 bg-white border-b border-gray-100 z-40">
      <div className="max-w-7xl mx-auto px-4 h-full flex items-center justify-between">
        <button 
          onClick={() => window.location.href = '/'}
          className="flex items-center space-x-2 hover:opacity-80 transition-opacity"
        >
          <img src="/images/gekkologo3.jpg" alt="Gekko Logo" className="w-12 h-12 rounded-full" />
          <span className="text-xl font-bold gradient-text">Gekko HQ</span>
          {department && (
            <>
              <span className="text-gray-300 mx-2">/</span>
              <span className="text-gray-600">{department}</span>
            </>
          )}
        </button>

        <div className="flex items-center space-x-4">
          {isAuthenticated ? (
            <>
              <span className="text-gray-600">
                Welcome, {user?.name}
              </span>
              <button
                onClick={handleLogout}
                className="text-gray-600 hover:text-gray-800"
              >
                Sign out
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate('/')}
                className="text-gray-600 hover:text-gray-800"
              >
                Sign in
              </button>
              <button
                onClick={() => navigate('/')}
                className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
              >
                Sign up
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}